import * as Yup from "yup";
import { StringSchema } from "yup";
import * as cpfValidator from "cpf-cnpj-validator";
import { isValid, parse } from "date-fns";

export const validateStringDate = (value: string) => {
  const parsed = parse(value, "dd/MM/yyyy", new Date());
  return isValid(parsed);
};

Yup.addMethod(Yup.string, "cpf", function (errorMessage) {
  return this.test(`test-cpf-type`, errorMessage, function (value) {
    const { path, createError } = this;

    return (
      cpfValidator.cpf.isValid(value || "") ||
      createError({ path, message: errorMessage })
    );
  });
});

Yup.addMethod(Yup.string, "stringDate", function (errorMessage) {
  return this.test(`test-string-date-type`, errorMessage, function (value) {
    const { path, createError } = this;

    return (
      validateStringDate(value || "") ||
      createError({ path, message: errorMessage })
    );
  });
});

const placeholderData = {
  nome: "Marcus Matos",
  cpf: "098.985.230-00",
  nascimento: "13/03/1989",
  rg: "55885588",
  org_exp: "SSP BA",
  data_exp: "13/03/1989",
  nacionalidade: "Brasileiro",
  endereco: "Av. Aruanã, 821",
  cidade: "Barueri",
  bairro: "Alphaville",
  cep: "06460010",
  email: "marcusamatos@gmail.com",
  celular: "(11) 98414-9366",
  comprovante_residencia: "bbf5ce941398ac597521e3a775d76662.pdf",
  estado_civil: "Casado(a)",
  conjuge_nome: "Conjuje 1",
  conjuge_cpf: "098.985.230-00",
  conjuge_nascimento: "13/03/1989",
  conjuge_rg: "55555555",
  conjuge_org_exp: "SSPSP",
  conjuge_data_exp: "13/03/1989",
  conjuge_email: "marcusamatos@gmail.com",
  conjuge_celular: "(11) 98414-9366",
  conjuge_comprovante: "bbf5ce941398ac597521e3a775d76662.pdf",
  dependentes: [
    {
      nome: "Dependente 1",
      nascimento: "13/03/1989",
      cpf: "098.985.230-00",
      certidao_nascimento: "bbf5ce941398ac597521e3a775d76662.pdf",
    },
  ],
};

export const initialValues = {
  nome: "",
  cpf: "",
  nascimento: "",
  rg: "",
  org_exp: "",
  data_exp: "",
  nacionalidade: "",
  endereco: "",
  cidade: "",
  bairro: "",
  cep: "",
  email: "",
  celular: "",
  comprovante_residencia: "",
  estado_civil: "Casado(a)",
  conjuge_nome: "",
  conjuge_cpf: "",
  conjuge_nascimento: "",
  conjuge_rg: "",
  conjuge_org_exp: "",
  conjuge_data_exp: "",
  conjuge_email: "",
  conjuge_celular: "",
  conjuge_comprovante: "",
  dependentes: [] as {
    nome: string;
    cpf: string;
    nascimento: string;
    certidao_nascimento: string;
  }[],
  _error: "",
  // ...placeholderData,
};

export type Values = {
  name: string;
  cpf: string;
  email: string;
  celular: string;
  _error?: string;
};

export const validationSchema = Yup.object().shape({
  nome: Yup.string()
    .min(2, "Mínimo de 5 caracteres!")
    .max(50, "Máximo de 50 caracteres!")
    .required("Preencha este campo."),
  cpf: Yup.string().cpf("CPF inválido!").required("Preencha este campo."),
  nascimento: Yup.string()
    .length(10, "Este campo ser no formato dd/mm/aaaa")
    .stringDate("Este campo ser no formato dd/mm/aaaa")
    .required("Preencha este campo."),
  rg: Yup.string()
    .min(8, "Mínimo de 8 caracteres!")
    .required("Preencha este campo."),
  org_exp: Yup.string().required("Preencha este campo."),
  data_exp: Yup.string()
    .stringDate("Este campo ser no formato dd/mm/aaaa")
    .required("Preencha este campo."),
  nacionalidade: Yup.string().required("Preencha este campo."),

  cep: Yup.string().required("Preencha este campo."),
  cidade: Yup.string().required("Preencha este campo."),
  bairro: Yup.string().required("Preencha este campo."),
  endereco: Yup.string().required("Preencha este campo."),
  email: Yup.string()
    .email("E-mail inválido!")
    .required("Preencha este campo."),
  celular: Yup.string().required("Preencha este campo."),
  comprovante_residencia: Yup.string().required(
    "Comprovante de residência é obrigatório!"
  ),
  estado_civil: Yup.string().required("Preencha este campo."),
  // Conjuje
  conjuge_nome: Yup.string(),
  conjuge_cpf: Yup.string().when("conjuge_nome", ([value], schema) =>
    value?.length > 0
      ? schema.cpf("CPF inválido!").required("Campo obrigatório")
      : schema
  ),
  conjuge_nascimento: Yup.string()
    .length(10, "Este campo ser no formato dd/mm/aaaa")
    .when("conjuge_nome", ([value], schema) =>
      value?.length > 0
        ? schema
            .stringDate("Este campo ser no formato dd/mm/aaaa")
            .required("Campo obrigatório")
        : schema
    ),
  conjuge_rg: Yup.string()
    .min(8, "Mínimo de 8 caracteres!")
    .when("conjuge_nome", ([value], schema) =>
      value?.length > 0 ? schema.required("Campo obrigatório") : schema
    ),
  conjuge_org_exp: Yup.string().when("conjuge_nome", ([value], schema) =>
    value?.length > 0 ? schema.required("Campo obrigatório") : schema
  ),
  conjuge_data_exp: Yup.string().when("conjuge_nome", ([value], schema) =>
    value?.length > 0
      ? schema
          .stringDate("Este campo ser no formato dd/mm/aaaa")
          .required("Campo obrigatório")
      : schema
  ),
  conjuge_email: Yup.string()
    .email("E-mail inválido!")
    .when("conjuge_nome", ([value], schema) =>
      value?.length > 0 ? schema.required("Campo obrigatório") : schema
    ),
  conjuge_celular: Yup.string()
    .min(8, "Mínimo de 8 caracteres!")
    .when("conjuge_nome", ([value], schema) =>
      value?.length > 0 ? schema.required("Campo obrigatório") : schema
    ),
  conjuge_comprovante: Yup.string().when("conjuge_nome", ([value], schema) =>
    value?.length > 0
      ? schema.required("Certidão de casamento ou união estável é obrigatório!")
      : schema
  ),
  dependentes: Yup.array().of(
    Yup.object().shape({
      nome: Yup.string()
        .min(2, "Mínimo de 5 caracteres!")
        .max(50, "Máximo de 50 caracteres!")
        .required("Preencha este campo."),
      cpf: Yup.string().cpf("CPF inválido!").required("Preencha este campo."),
      nascimento: Yup.string()
        .length(10, "Este campo ser no formato dd/mm/aaaa")
        .stringDate("Este campo ser no formato dd/mm/aaaa")
        .required("Preencha este campo."),
      certidao_nascimento: Yup.string().required(
        "A certidão de nascimento é obrigatória!"
      ),
    })
  ),
  doc_residencia: Yup.string(),
  doc_certidao: Yup.string(),
});

export const cpfMask = (value: string) => {
  return value
    .replace(/\D/g, "") // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{3})(\d)/, "$1.$2") // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1"); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
};

export const dateMask = (value: string) => {
  return value
    .replace(/\D/g, "") // remove tudo que não for número
    .replace(/(\d{2})(\d)/, "$1/$2") // insere a primeira barra após os dois primeiros dígitos (dia)
    .replace(/(\d{2})(\d)/, "$1/$2") // insere a segunda barra após os dois dígitos seguintes (mês)
    .replace(/(\/\d{4})\d+?$/, "$1"); // limita o ano a 4 dígitos
};
export const rgMask = (value: string) => {
  return value.replace(/\D/g, "").substring(0, 8);
};

export const rgMask2 = (value: string) => {
  return value
    .replace(/\D/g, "") // remove tudo que não for número
    .replace(/(\d{2})(\d)/, "$1.$2") // 00.0
    .replace(/(\d{3})(\d)/, "$1.$2") // 00.000.0
    .replace(/(\d{3})(\d{1})$/, "$1-$2") // 00.000.000-0
    .replace(/(-\d)\d+?$/, "$1")
    .substring(0, 14);
};

export const MascaraRG = (v0: string, errChar = "?") => {
  const v = v0.toUpperCase().replace(/[^\dX]/g, "");
  return v.length === 8 || v.length === 9
    ? v.replace(/^(\d{1,2})(\d{3})(\d{3})([\dX])$/, "$1.$2.$3-$4")
    : errChar + v0;
};

export const cepMask = (value: string) => {
  return value
    .replace(/\D/g, "") // remove tudo que não for número
    .replace(/(\d{5})(\d)/, "$1-$2") // insere o hífen após o quinto dígito
    .replace(/(-\d{3})\d+?$/, "$1"); // limita a 8 dígitos no total
};

export const phoneMask = (value: string) => {
  return value
    .replace(/\D/g, "") // remove tudo que não for número
    .replace(/(\d{2})(\d)/, "($1) $2") // insere os parênteses no DDD
    .replace(/(\d{5})(\d)/, "$1-$2") // insere o hífen depois do quinto dígito do número
    .replace(/(-\d{4})\d+?$/, "$1"); // limita o número final a 4 dígitos
};
